import axios from 'axios';
import { API } from '../config';

axios.defaults.headers.post['Access-Control-Allow-Origin'] = "*";
axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';

const path = "/criancas";


class RestricaoService {

    listaRestricao(idCrianca) {
        return axios.get(API + path + `/${idCrianca}/restricao`)
    }

    postRestricao(idCrianca, RestricaoRequest) {
        return axios.post(API + path + `/${idCrianca}/restricao`, RestricaoRequest)
    }

    getRestricaoId(idCrianca, idRestricao) {
        return axios.get(API + path + `/${idCrianca}/restricao/${idRestricao}`)
    }

    putRestricao(idCrianca, idRestricao, RestricaoRequest) {
        return axios.put(API + path + `/${idCrianca}/restricao/${idRestricao}`, RestricaoRequest)
    }

    deleteRestricao(idCrianca, idRestricao) {
        return axios.post(API + path + `/${idCrianca}/restricao/${idRestricao}/inativar`)
    }

    liberarRestricao(idCrianca, idRestricao, liberacaoRequest) {
        return axios.post(API + path + `/${idCrianca}/restricao/${idRestricao}/liberar`, liberacaoRequest)
    }

    getRelacionamentoRestricao(idCrianca) {
        return axios.get(API + path + `/${idCrianca}/restricao/relacionamentos-vinculos`)
    }

    getAnexoTermoRestricao(idCrianca, idRestricao) {
        return axios.get(API + path + `/${idCrianca}/restricao/${idRestricao}/anexo-restricao`)
    }

    postAnexoTermoRestricao(idCrianca, anexo, anexoRequest) {
        var formData = new FormData();
        formData.append('anexo', anexo);

        formData.append('idRestricao', anexoRequest);

        return axios.post(API + path + `/${idCrianca}/restricao/anexo-restricao`, formData)
    }

    getAnexoTermoLiberacao(idCrianca, idLiberacao) {
        return axios.get(API + path + `/${idCrianca}/restricao/${idLiberacao}/anexo-liberacao`)
    }

    postAnexoTermoLiberacao(idCrianca, anexo, anexoRequest) {
        var formData = new FormData();

        formData.append('anexo', anexo);
        formData.append('idRestricao', anexoRequest);

        return axios.post(API + path + `/${idCrianca}/restricao/anexo-liberacao`, formData)
    }

}

const instanceRestricaoService= new RestricaoService();
export default instanceRestricaoService;